import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class ClassRecordNavigationButtons {
	constructor(previous, next) {
		let previousBtn = document.getElementById('previousClassRecordButton');
		let nextBtn = document.getElementById('nextClassRecordButton');

		previousBtn.disabled = (null==previous) || (!(('undefined' != typeof previous) && (0!=previous.Id)));
		nextBtn.disabled = (null==next) || (!(('undefined'!=typeof next) && (0!=next.Id)));

		let navigate = (courseId)=> {
			return (evt)=> {
				evt.stopPropagation();
				evt.preventDefault();
				document.location = `/classrecord/${courseId}/edit`;
				return false;
			}
		}
		if (null!=previous) {
			previousBtn.addEventListener('click', navigate(previous.Id));
			if ('undefined'!= typeof previous.Name)
				previousBtn.appendChild(document.createTextNode(previous.Name));
		}
		if (null!=next) {
			nextBtn.addEventListener('click', navigate(next.Id));
			if ('undefined' != typeof next.Name)
				nextBtn.appendChild(document.createTextNode(next.Name));
		}
	}
}

window.ClassRecordNavigationButtons = ClassRecordNavigationButtons;